import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-page-shell',
  template: `
    <main class="page-shell">
      <h1 data-testid="page-shell-heading">My Orders History</h1>
    </main>
  `,
  styles: `
    .page-shell {
      padding: 2rem;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageShellComponent {}
